<template>
    <AuthenticatedLayout
        :title="__('Contact')"
        :footerContainer="false"
    >
    <div class="max-w-screen-xl w-full mx-auto">

        <div class="relative grid grid-cols-6 gap-3">
            <div class="bg-white text-gray-900 rounded-md shadow-md lg:col-span-4 col-span-full">
            <div class="p-8">
                <h2 class="border-b-2 border-red-700 mb-5 pb-4 text-center text-2xl font-bold">{{__('Get in touch')}}</h2>
                <div class="grid grid-cols-2 gap-3">
                    <InputLabel
                        id="email"
                        :label="__('Email')"
                        type="email"
                        class="block w-full sm:col-span-1 col-span-2"
                        v-model="contact_form.email"
                    />
                    <InputLabel
                        id="username"
                        :label="__('Name')"
                        class="block w-full sm:col-span-1 col-span-2"
                        v-model="contact_form.username"
                    />
                    <InputLabel
                        id="content"
                        :label="__('Message')"
                        type="textarea"
                        class="block w-full col-span-2"
                        rows="10"
                        v-model="contact_form.content"
                    />
                    <div class="col-span-2">
                        <label for="file" />
                        <input id="file" type="file" @change="ev => {
                            contact_form.file = ev.target.files[0];
                            $page.props.errors.file = null
                        }">
                        <div
                            v-if="checkError($page.props.errors, 'file')"
                            class="text-red-500 text-xs font-bold"
                        >{{checkError($page.props.errors, 'file')}}</div>
                    </div>
                    <vueRecaptcha
                        class="col-span-full overflow-auto"
                        v-if="showRecaptcha"
                        :size="captcha_option.size"
                        :siteKey="captcha_option.siteKey"
                        :tabindex="0"
                        @verify="recaptchaVerified"
                        @expire="recaptchaExpired"
                        @fail="recaptchaFailed"

                        :ref="el => { vueRecaptcha = el }"
                    ></vueRecaptcha>
                    <Button
                        class="font-bold justify-center"
                        padding="md"
                        color="gray"
                        @click="sendForm"
                        v-if="showButton"
                        :loading="contact_form.processing"
                    >
                        {{__('Send')}}
                    </Button>
                </div>
            </div>
            <div class="p-3 bg-red-800 rounded-b-md text-gray-200">
                <ul class="md:text-xl text-lg py-2">
                    <li>
                        <a class="flex items-center justify-center w-min mx-auto hover:underline" :href="'mailto:' + $page.props.siteData.email">
                        <SvgIcon class="mr-1" name="email"/>
                        {{$page.props.siteData.email}}
                        </a>
                    </li>
                </ul>
            </div>
            </div>
            <div class="text-center bg-gray-900 text-gray-200 rounded-md shadow-md relative p-8 flex flex-col lg:col-span-2 col-span-full">
                <h2 class="border-b-2 border-red-700 pb-5 text-2xl font-bold">{{__('Find us')}}</h2>

                <ul class="md:text-xl text-lg py-5 space-y-2">
                    <li class="flex items-center justify-center">
                        <SvgIcon class="mr-1" :size="30" name="geo"/>
                        <div class="text-center" v-html="'Forte-Studio</br>' + $page.props.siteData.address.replace(/\n/g, '<br />')"></div>
                    </li>
                </ul>
                <iframe
                    style="min-height: 250px;"
                    class="h-full w-full rounded-md"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d5164.275005362129!2d14.556124898771108!3d52.34841939952462!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4707a282ad98fdef%3A0x5d70b7d39309b10a!2sKonopnickiej%205%2F33%2C%2069-100%20S%C5%82ubice!5e0!3m2!1spl!2spl!4v1631529533273!5m2!1spl!2spl"
                    allowfullscreen=""
                    loading="lazy"
                ></iframe>
            </div>
        </div>
    </div>
    </AuthenticatedLayout>
</template>

<script>
import AuthenticatedLayout from '@/Layouts/Authenticated';
import SvgIcon from 'UI/SvgIcon';
import Heading from 'COMP/Heading';
import CustomSelect from 'UI/CustomSelect';
import InputLabel from 'UI/InputLabel';

import vueRecaptcha from 'vue3-recaptcha2';

import { useForm } from '@inertiajs/inertia-vue3'
import Button from 'UI/Button';

import {
    checkError,
    getFullName
} from 'helper';
import { ref } from '@vue/reactivity';

export default {
    components: {
        AuthenticatedLayout,
        SvgIcon,
        Heading,
        CustomSelect,
        InputLabel,
        Button,
        vueRecaptcha,
    },
    props: {
        auth: Object,
        loggedin: Boolean,
    },
    setup(props) {
        const contact_form = useForm({
            email: props.loggedin ? props.auth.user.email : null,
            username: props.loggedin ? getFullName(props.auth.user) : null,
            content: null,
            file: null,
            recaptcha_token: null,
        })
        const sendForm = () => {
            contact_form.post('/contact_form', {
                preserveScroll: true,
                onSuccess: () => { contact_form.reset(); recaptchaExpired(); }
            });
        }


        const width = ref(window.screen.width);
        const captcha_option = ref({
            size: width.value < 500 ? 'compact' : 'normal',
            siteKey: process.env.RECAPTCHA_SITE_KEY,
        });

        const showRecaptcha = ref(true);
        const showButton = ref(false);
        const vueRecaptcha = ref(null);

        function recaptchaVerified(response) {
            showButton.value = true;
            contact_form.recaptcha_token = response;
        };
        function recaptchaExpired() {
            showButton.value = false;
            contact_form.recaptcha_token = false;

            vueRecaptcha.value.reset();
        };
        function recaptchaFailed() {
            showButton.value = false;
            contact_form.recaptcha_token = false;
        }

        return {
            contact_form,
            sendForm,
            checkError,
            getFullName,

            showRecaptcha,
            vueRecaptcha,
            showButton,

            recaptchaVerified,
            recaptchaExpired,
            recaptchaFailed,

            captcha_option
        }
    },
}
</script>
